/*
 * @Author:
 * @Description:
 * @Date: 2025-03-02 20:22:12
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-merchant-web/src/utils/tools/validater.js
 */

// 判断表单值是否为空 (包括空字符串、空数组、空对象等)
export const isEmptyValue = (value) => {
  // 判断 null 和 undefined
  if (value === null || value === undefined) {
    return true;
  }
  // 判断空字符串
  if (typeof value === 'string') {
    return value.trim().length === 0;
  }
  // 判断空数组
  if (Array.isArray(value)) {
    return value.length === 0;
  }
  // 判断空对象
  if (typeof value === 'object') {
    return Object.keys(value).length === 0;
  }
  return false;
};
